module.exports = __webpack_public_path__ + "img/ExhibitionView4.6cd2e290.jpg";